module.exports = __webpack_public_path__ + "img/placeholder-lands.87df9c85.svg";